import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: "root"
})

export class AppConfigService {
    public APLICACION_AMBIENTE: string = "desarrollo";
    public APLICACION_USUARIO_WINDOWS: string = "exsys";
    public APLICACION_ID_SESION: string = "";
    public APLICACION_PERFIL: string = "";
    // public APLICACION_PERFIL: string="ADMINISTRADOR";
    public APLICACION_ID_EMPRESA = 4; //OEFA
    public APLICACION_ID_SISTEMA = 5; //PIA
    public ID_SUBSECTOR: string;
    public ID_USUARIO: string = '0';
    public APLICACION_NOMBRE = "Plataforma de Gestion Documental";
    // Para evitar Alfresco.
    public ENTORNO: string = "dev"; // Equipos dentro de OEFA
    // public ENTORNO: string = "local"; // Equipos fuera de OEFA

    public CANTIDAD_BANDEJA = 25;

    constructor() {
        this.APLICACION_AMBIENTE = environment.name_service;
     }

    obtenerImagen(idPlugin) {
        switch (idPlugin) {
            case 11:
                return "assets/images/process.png";
            case 12:
                return "assets/images/checklist (1).png";
            case 13:
                return "assets/images/microscope.png";
            case 14:
                return "assets/images/file (1).png";
            case 21:
                return "assets/images/arrows.png";
            case 22:
                return "assets/images/waste.png";
            case 23:
                return "assets/images/house.png";
            case 24:
                return "assets/images/file (2).png";
            case 31:
                return "assets/images/graph.png";
            case 32:
                return "assets/images/analysis.png";
            default:
                break;
        }
    }
}
